import { BrowserRouter as Route } from "react-router-dom";
import React from "react";
import Routes from "../Routes/Routes";

const App = () => {
  return (
    <Route>
      <Routes />
    </Route>
  );
};

export default App;
